import styled from "styled-components";

export const Container = styled.div`
  flex: 1;
  height: 90vh;
  background: #242426;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const BuildsTitle = styled.h2`
  color: white;
  font-size: 36px;
  align-self: center;
  font-weight: 300;
  font-family: 'Dongle', sans-serif;
`;

export const CenterContent = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 600px;
  margin: 60px;
  flex: 1;
`;